import "./Calendar.css"
import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Row, Col, Spinner } from 'react-bootstrap'
import { TopbarContext } from '../Library/TopbarContext'
import { LanguageContext } from '../Language/LanguageContext'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import thLocale from '@fullcalendar/core/locales/th'
import { listCalendar, getCalendar, deleteCalendar } from '../Network/Calendar'
import { NotifyContext } from '../Library/Notify'
import { Checkbox, Container, HeaderTitle } from '../Library'
import dayjs from 'dayjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from '../Role/RoleContext'
import { AlertModalContext } from '../Library/AlertModalContext'

function Calendar() {
  const history = useHistory()
  const [isLoading, setLoading] = useState(false)
  const alertModal = useContext(AlertModalContext)
  const role = useContext(RoleContext)
  const topbarCx = useContext(TopbarContext)
  const langCx = useContext(LanguageContext)
  const notify = useContext(NotifyContext)
  const lang = langCx.lang.calendar
  const langCode = langCx.code
  const [isAll, setIsAll] = useState(true)
  const [isGlobal, setGlobal] = useState(true)
  const [events, setEvents] = useState([])
  const [currentDate, setCurrentDate] = useState(new Date())
  const [selectedCalendar, setSelectedCalendar] = useState(null)

  const handleDateSelect = (selectInfo) =>{
    let calendarApi = selectInfo.view.calendar

    calendarApi.unselect() // clear date selection
  }

  const handleEventCalendar = (selectInfo) =>{
    let info = selectInfo.event.title
    let findTitle = events.find((el)=>el.title === info)
    let eventId = findTitle.id
    getCalendarInfo(eventId)
  }

  const getCalendarInfo = (eventId) =>{
    setLoading(true)
    getCalendar(eventId,
      (data)=>{
        setSelectedCalendar(data)
        setLoading(false)
      },
      (error)=>{
        notify.showNotify("Something wrong", error.message, 2)
        setLoading(false)
      })
  }

  const deleteEvent = (eventId) =>{
    alertModal.setTitle(lang.delete_event)
    alertModal.setDescription(lang.sure_to_delete)
    alertModal.setAlertType("EXTREME")
    alertModal.setButton([
      {
          title: langCx.lang.confirm.ok,
          variant: "danger",
          onClick: ()=>{ 
              alertModal.setIsShow(false)
              setLoading(true)
              deleteCalendar(eventId,
                ()=>{
                  notify.showNotify(lang.delete_success, lang.delete_success_desc, 0)
                  setSelectedCalendar(null)
                  fetchCalendar(currentDate, isAll, isGlobal)
                  setLoading(false)
                },
                (error)=>{
                  notify.showNotify("Something wrong", error.message, 2)
                  setLoading(false)
                })
          }
      },
      {
          title: langCx.lang.confirm.cancel,
          variant: "secondary",
          onClick: ()=>{ 
              alertModal.setIsShow(false) 
          }
      }
    ])
    alertModal.setIsShow(true)
    // if(window.confirm(lang.sure_to_delete)){
    //   setLoading(true)
    //   deleteCalendar(eventId,
    //     ()=>{
    //       notify.showNotify(lang.delete_success, lang.delete_success_desc, 0)
    //       setSelectedCalendar(null)
    //       fetchCalendar(currentDate, isAll, isGlobal)
    //       setLoading(false)
    //     },
    //     (error)=>{
    //       notify.showNotify("Something wrong", error.message, 2)
    //       setLoading(false)
    //     })
    // }
  }

  const fetchCalendar = (currentDate, isAll, isGlobal) =>{
    setLoading(true)
    listCalendar(currentDate, isAll, isGlobal, 
      (data)=>{
        var eventList = []
        data.forEach((item)=>{
          eventList.push({
            title: item.title, 
            start: item.eventStart, 
            end: item.eventEnd, 
            allDay: item.allDay, 
            id: item.id
          })
        })
        setEvents(eventList)
        setLoading(false)
      },
      (error)=>{
        console.log(error)
        notify.showNotify("Something wrong", error.message, 2)
        setLoading(false)
      })
  }

  const convertDateTimeFormat = (toDate) =>{
    let date = new Date(toDate)
    let formatted = dayjs(date).format("D MMMM YYYY - H:mm")
    return formatted
  }
  const convertDateFormat = (toDate) =>{
    let date = new Date(toDate)
    let formatted = dayjs(date).format("D MMMM YYYY")
    return formatted
  }

  useEffect(()=>{
    const fetchCalendar = (currentDate, isAll, isGlobal) =>{
      setLoading(true)
      listCalendar(currentDate, isAll, isGlobal, 
        (data)=>{
          var eventList = []
          data.forEach((item)=>{
            eventList.push({
              title: item.title, 
              start: item.eventStart, 
              end: item.eventEnd, 
              allDay: item.allDay, 
              id: item.id
            })
          })
          setEvents(eventList)
          setLoading(false)
        },
        (error)=>{
          console.log(error)
          notify.showNotify("Something wrong", error.message, 2)
          setLoading(false)
        })
    }
    setDocumentTitle("Calendar")
    topbarCx.setTopTitle(lang.calendar)
    fetchCalendar(new Date(), true, true)
  },[lang.calendar, notify, topbarCx])

  return (
    <Container id="eventlist" topbarTitle={langCx.lang.sidebar.calendar}>
      <HeaderTitle title={lang.calendar_and_activty}/>
      <div className="event-top">
        <div className="options">
          { role.checkPermission("_MENU_", "app.calendar_add") ?
          <Button
          style={{marginBottom: 20, marginRight: 20}}
          onClick={()=>history.push("/calendar/add")}
          >
            {lang.create_event}
          </Button>
          : null
          }
          <Checkbox
          label={lang.public}
          defaultChecked={isGlobal ? true:false}
          value={isGlobal}
          onChange={()=>{
            const gb = !isGlobal ? true:false
            setGlobal(gb)
            fetchCalendar(currentDate, isAll, gb)
          }}
          style={{marginRight: 20}}
          />
          <Checkbox
          label={lang.is_all}
          defaultChecked={isAll ? true:false}
          value={isAll}
          onChange={()=>{
            const all = !isAll ? true:false
            setIsAll(all)
            fetchCalendar(currentDate, all, isGlobal)
          }}
          />
        </div>
        <div>
          { isLoading ?
          <Spinner 
          variant="primary" 
          animation="border" 
          className="spinner"/>
          : null
          }
        </div>
      </div>
      <div>
        <Row>
          <Col lg={8}>
            <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            initialView="dayGridMonth"
            events={events}
            locale={langCode === "th" ? thLocale:null}
            select={handleDateSelect}
            datesSet={(date)=>{
              fetchCalendar(date.view.currentStart, isAll, isGlobal)
              setCurrentDate(date.view.currentStart)
            }}
            eventClick={handleEventCalendar}
            />
          </Col>
          <Col lg={4}>
            { selectedCalendar !== null ?
            <div id="selected-calendar">
              
              <div className="highlight">
                <div className="event-day">
                  <div className="day-of-week">{dayjs(selectedCalendar.eventStart).format("dddd")}</div>
                  <div className="month">{dayjs(selectedCalendar.eventStart).format("MMMM")}</div>
                  <div className="day"
                  style={{color: selectedCalendar.type === "HOLIDAY" ? "red": "black"}}>
                    {dayjs(selectedCalendar.eventStart).format("D")}
                  </div>
                </div>
                <div style={{marginLeft: 20}}>
                  <div className="title"><b>{selectedCalendar.title}</b></div>
                  <div className="desc">
                    {selectedCalendar.description}
                  </div>
                </div>
              </div>
             
              <hr/>
              { !selectedCalendar.allDay ?
                <>
                  <div>{lang.start_date} : {convertDateTimeFormat(selectedCalendar.eventStart)}</div>
                  <div>{lang.end_date} : {convertDateTimeFormat(selectedCalendar.eventEnd)}</div>
                </>
              : 
                <>
                  <div>{lang.date} : {convertDateFormat(selectedCalendar.eventStart)}</div>
                </>
              }
              <hr/>
              <div>
                <div>{lang.location} : {selectedCalendar.location}</div>
              </div>
              <hr/>
              { (selectedCalendar.global && role.checkPermission("NEWS_","SET_GLOBAL")) ||  
              (!selectedCalendar.global )
              ? 
              <div>
                <Button
                onClick={()=>history.push("/calendar/edit/" + selectedCalendar.id)}>
                  {lang.edit_event}
                </Button>
                <Button
                style={{marginLeft: 10}}
                variant="danger"
                onClick={()=>deleteEvent(selectedCalendar.id)}>
                  {lang.delete_event}
                </Button>
              </div>
              : null
              }
            </div>
            
            : 
            <div className="no-select">
              <div className="icon">
                <FontAwesomeIcon icon={faCalendar}/>
              </div>
              <div className="title">
                {lang.click_event}
              </div>
            </div>
            }
          </Col>
        </Row>
        
      </div>
    </Container>
  )
}

export default Calendar